import React from 'react'
import Icon from 'components/elements/Icon'

import { ImageSize } from 'redux/collectionV2/types'

import { useActionless, useAppSelector } from 'redux/hooks'
import { SET_COLLECTION_V2_STATE } from 'redux/collectionV2/actions/types'

import styles from './imageSizeControls.module.scss'

const ImageSizeControls = () => {
  const imageSize = useAppSelector(state => state.collectionV2.imageSize)

  const [setCollectionV2State] = useActionless(SET_COLLECTION_V2_STATE)

  const handleChangeImageSize = (imageSize: ImageSize) => setCollectionV2State({ imageSize })

  const handleMakeSmaller = () => {
    if (imageSize === 'normal') return handleChangeImageSize('small')
    if (imageSize === 'large') return handleChangeImageSize('normal')

    return handleChangeImageSize('small')
  }

  const handleMakeLarger = () => {
    if (imageSize === 'normal') return handleChangeImageSize('large')
    if (imageSize === 'small') return handleChangeImageSize('normal')

    return handleChangeImageSize('large')
  }

  return (
    <div className={styles.sizeSelector}>
      <button onClick={handleMakeSmaller} className={`${styles.indicator} ${styles.smaller}`}>
        <Icon name="image outline" />
      </button>
      <div className={styles.options}>
        <button disabled={imageSize === 'small'} onClick={() => handleChangeImageSize('small')}>
          <Icon name={imageSize === 'small' ? 'circle' : 'circle outline'} />
        </button>
        <button disabled={imageSize === 'normal'} onClick={() => handleChangeImageSize('normal')}>
          <Icon name={imageSize === 'normal' ? 'circle' : 'circle outline'} />
        </button>
        <button disabled={imageSize === 'large'} onClick={() => handleChangeImageSize('large')}>
          <Icon name={imageSize === 'large' ? 'circle' : 'circle outline'} />
        </button>
      </div>
      <button onClick={handleMakeLarger} className={`${styles.indicator} ${styles.larger}`}>
        <Icon name="image outline" />
      </button>
    </div>
  )
}

export default ImageSizeControls
